define("@ember-data/model/index", ["exports", "@ember-data/model/-private"], function (_exports, _private) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "attr", {
    enumerable: true,
    get: function () {
      return _private.attr;
    }
  });
  Object.defineProperty(_exports, "belongsTo", {
    enumerable: true,
    get: function () {
      return _private.belongsTo;
    }
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function () {
      return _private.Model;
    }
  });
  Object.defineProperty(_exports, "hasMany", {
    enumerable: true,
    get: function () {
      return _private.hasMany;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"@ember-data/model/-private"eaimeta@70e063a35619d71f
  /**
   In EmberData a `Model` is a class defining the attributes and relationships
    of a specific resource `type` (model name). In this sense it represents a static "schema".
  
    Data for individual resources fetched from your API is presented
    to the UI via instances of the `Model`s you define.
  
    An instantiated `Model` is referred to as a `record`.
  
    When we refer to the `ModelClass` we are referring to the class definition
    and the static schema methods present on it.
  
    When we refer to a `record` we refer to a specific class instance presenting
    the resource data for a given `type` and `id`.
  
    ### Defining a Model
  
    ```app/models/person.js
    import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
  
    export default class PersonModel extends Model {
      @attr name;
  
      @belongsTo('pet', { inverse: 'owners', async: false }) dog;
  
      @hasMany('person', { inverse: 'friends', async: true }) friends;
    }
    ```
  
    ### modelName convention
  
    By convention, the name of a given model (its `type`) matches the name
    of the file in the `app/models` folder and should be lowercase, singular
    and dasherized.
  
    @module @ember-data/model
    @main @ember-data/model
   */
});